var _rect, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCash(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5.377,
    y: 3.081,
    width: 21.246,
    height: 25.967,
    rx: 1,
    stroke: "currentColor",
    strokeWidth: 1.25
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.377 3.672l10.207 6.804a.75.75 0 00.832 0l10.207-6.804",
    stroke: "currentColor",
    strokeWidth: 1.25
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzIiIGhlaWdodD0iMzIiIHZpZXdCb3g9IjAgMCAzMiAzMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3QgeD0iNS4zNzY5NSIgeT0iMy4wODA4MSIgd2lkdGg9IjIxLjI0NTkiIGhlaWdodD0iMjUuOTY3MiIgcng9IjEiIHN0cm9rZT0iY3VycmVudENvbG9yIiBzdHJva2Utd2lkdGg9IjEuMjUiLz4KPHBhdGggZD0iTTUuMzc3MTIgMy42NzE2OUwxNS41ODQxIDEwLjQ3NjNDMTUuODM2IDEwLjY0NDMgMTYuMTY0MiAxMC42NDQzIDE2LjQxNjEgMTAuNDc2M0wyNi42MjMgMy42NzE2OSIgc3Ryb2tlPSJjdXJyZW50Q29sb3IiIHN0cm9rZS13aWR0aD0iMS4yNSIvPgo8L3N2Zz4K";
export { SvgCash as ReactComponent };